import { NavigationContainerRefWithCurrent } from '@react-navigation/native'
import { createNativeStackNavigator } from '@react-navigation/native-stack'
import {
  UpspaceDescriptionPage,
  UpspaceImagePage,
  UpspaceNamePage,
  UpspaceNextPage,
} from 'components/pages/CoachOnboarding'
import { FlowSelectionPage } from 'components/pages/CoachOnboarding/FlowSelectionPage'
import { ProgramDescriptionPage } from 'components/pages/CoachOnboarding/ProgramPages/ProgramDescriptionPage'
import { ProgramImagePage } from 'components/pages/CoachOnboarding/ProgramPages/ProgramImagePage'
import { ProgramNamePage } from 'components/pages/CoachOnboarding/ProgramPages/ProgramNamePage'
import { ProgramQuestionsPage } from 'components/pages/CoachOnboarding/ProgramPages/ProgramQuestionsPage'
import React from 'react'

import { useFeatureFlags } from 'hooks/useFeatureFlags'

import * as constants from 'utils/constants'

export type CoachOnboardingStackParamList = {
  [constants.links.FLOW_SELECION_PAGE]: undefined
  [constants.links.UPSPACE_NAME_PAGE]: undefined
  [constants.links.UPSPACE_DESCRIPTION_PAGE]: undefined
  [constants.links.UPSPACE_IMAGE_PAGE]: undefined
  [constants.links.UPSPACE_NEXT_PAGE]: undefined
  [constants.links.PROGRAM_QUESTIONS_PAGE]: undefined
  [constants.links.PROGRAM_DESCRIPTION_PAGE]: undefined
  [constants.links.PROGRAM_NAME_PAGE]: undefined
  [constants.links.PROGRAM_IMAGE_PAGE]: undefined
}

const Stack = createNativeStackNavigator<CoachOnboardingStackParamList>()

export const CoachOnboardingStack = ({
  setPrimaryBg,
  drawerNavigationRef,
  ...rest
}: {
  setPrimaryBg: (value: boolean) => void
  drawerNavigationRef: NavigationContainerRefWithCurrent<ReactNavigation.RootParamList>
}) => {
  const skipSelectionPage = rest?.data?.skipSelectionPage

  const { isProgramsFlagEnabled } = useFeatureFlags()

  return (
    <Stack.Navigator
      id='CoachOnboardingStackNavigator'
      screenOptions={{
        headerShown: false,
        presentation: 'containedTransparentModal',
        animation: 'none',
      }}
    >
      {isProgramsFlagEnabled && !skipSelectionPage && (
        <Stack.Screen
          name={constants.links.FLOW_SELECION_PAGE}
          component={(props: any) => (
            <FlowSelectionPage handleSelection={setPrimaryBg} {...props} />
          )}
        />
      )}

      {isProgramsFlagEnabled && (
        <>
          <Stack.Screen
            name={constants.links.PROGRAM_QUESTIONS_PAGE}
            component={() => <ProgramQuestionsPage isInitialPage={skipSelectionPage} />}
          />

          <Stack.Screen
            name={constants.links.PROGRAM_DESCRIPTION_PAGE}
            component={ProgramDescriptionPage}
          />

          <Stack.Screen name={constants.links.PROGRAM_NAME_PAGE} component={ProgramNamePage} />

          <Stack.Screen
            name={constants.links.PROGRAM_IMAGE_PAGE}
            component={(props: any) => (
              <ProgramImagePage drawerNavigationRef={drawerNavigationRef} {...props} />
            )}
          />
        </>
      )}

      <Stack.Screen
        name={constants.links.UPSPACE_NAME_PAGE}
        component={(props: any) => <UpspaceNamePage handleSelection={setPrimaryBg} {...props} />}
      />

      <Stack.Screen
        name={constants.links.UPSPACE_DESCRIPTION_PAGE}
        component={UpspaceDescriptionPage}
      />

      <Stack.Screen name={constants.links.UPSPACE_IMAGE_PAGE} component={UpspaceImagePage} />
      <Stack.Screen
        name={constants.links.UPSPACE_NEXT_PAGE}
        component={() => <UpspaceNextPage drawerNavigationRef={drawerNavigationRef} />}
      />
    </Stack.Navigator>
  )
}
